import ReactDOM from "react-dom";
import { TableWrapper } from "./components/TableWrapper";

(() => {
  const containers = document.querySelectorAll<HTMLElement>(
    "[data-mediawijs-tussendoortjes]"
  );

  const data = document.getElementById("tussendoortjes-data")?.textContent;

  if (!containers || !data) return;

  ReactDOM.render(<TableWrapper rows={JSON.parse(data).rows} />, containers[0]);
})();
